type WelcomeTrustIconProps = {
  icon: "lock" | "shield";
  className?: string;
};

export const WelcomeTrustPrivacyIcon = ({
  icon,
  className,
}: WelcomeTrustIconProps) => {
  if (icon === "shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
        <path
          d="M12 4.9 18 7v4.4c0 3.4-2.2 6.2-6 7.7-3.8-1.5-6-4.3-6-7.7V7l6-2.1Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m9.2 12.2 1.8 1.8 3.8-3.8"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <rect
        x="6.5"
        y="10.5"
        width="11"
        height="9"
        rx="1.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M9 10.5V8.4a3 3 0 0 1 6 0v2.1"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
};
